module.exports = __webpack_public_path__ + "files/0504561779985eabca159376e95b9201.png";